import { PageChrome, ROUTES } from '@/components/gg/chrome'
import { Affiliate } from '@/pages/Affiliate'

/** Affiliate (/app/affiliate): the pitch, the application and the dashboard. */
export function AffiliatePage() {
  return (
    <>
      <PageChrome title="Affiliate" navKey="affiliate" back={{ to: ROUTES.settings, label: 'Settings' }} />
      <Affiliate />
    </>
  )
}
